import { CMDGiftLog } from "./CMDGiftLog"
import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpGiftLogQuery implements ICommand
{

	public Gift : Array<CMDGiftLog>;

	public constructor()
	{
		this.Gift = new Array<CMDGiftLog>();
	}

	public fromBytes(ba : ByteArray) : void
	{
		let GiftSize:number = ba.readUint32();
		while (GiftSize-- > 0)
		{
			let GiftChild:CMDGiftLog = new CMDGiftLog();
			GiftChild.fromBytes(ba);
			this.Gift.push(GiftChild);
		}
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint32(this.Gift.length);
		for (const GiftChild of this.Gift)
		{
			let tempBuf = GiftChild.toBytes();
			ba.appendBuf(tempBuf.toBuffer());
		}

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpGiftLogQuery();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Gift_size(D)='+this.Gift.length + ' ';
		str += 'Gift(CMDGiftLog)=[';
		for (let GiftChild in this.Gift)
		{
			if (<number><unknown>GiftChild > 0) str += ', ';
			str += this.Gift[GiftChild].toString();
		}
		str += '] ';
		return str;
	}

	public getCmdID() : number
	{
		return 50139;
	}

	public getCmdName() : string
	{
		return 'SpGiftLogQuery';
	}

}
